import { Autocomplete, Text } from '../1elements'
import { useEffect, useState } from 'react'
import ApiService from '../../common/ApiCalls'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import FormTextField from './FormTextField'
import { validateAutocompleteBuildingName, validateBuildingName } from '../../services/util/editChecks'
import Box from '@mui/material/Box'

const autocompleteSx = {
  padding: 0,
  '& .MuiInputBase-root': {
    padding: 0
  },
  '& .MuiAutocomplete-inputRoot': {
    maxHeight: '29px'
  },
  '& .MuiInputBase-input': {
    height: '10px'
  }
}

const BuildingName = ({ manualInput, setManualInput, value, setValue, showError, fieldType, setFieldType, disabled }) => {
  const [buildingNameList, setBuildingNameList] = useState([])
  const [searchWord, setSearchWord] = useState('')

  const updateSearchWord = (e) => {
    setSearchWord(e.target.value)
  }

  const switchBuildingNameField = () => {
    setFieldType(prevState =>
      prevState === 'Autocomplete' ? 'TextField' : 'Autocomplete'
    )
  }

  useEffect(() => {
    if (searchWord.length > 0) {
      const keyword = { searchInput: searchWord }
      ApiService().searchBuildingByName(keyword)
        .then((res) => {
          setBuildingNameList(res)
        })
        .catch((err) => {
          console.log('error in searchBuildingByName', err)
        })
    } else {
      setBuildingNameList([])
    }
  }, [searchWord])

  return (
    <div>

      {
                fieldType === 'Autocomplete'
                  ? (<>
                    <Text type='fieldLabel'>Building Name<span className='requiredAsterisk'>*</span></Text>
                    <Autocomplete
                      sx={autocompleteSx} options={buildingNameList}
                      optionLabel='name' value={value} onChangeTextField={updateSearchWord}
                      onChangeAutocomplete={setValue}
                      validation={showError && validateAutocompleteBuildingName(value)}
                      disabled={disabled}
                    />

                    <Box sx={{ marginBottom: '40px' }}>
                      {!disabled && (
                        <div onClick={switchBuildingNameField}>
                          <Text type='addBuildingNameCta'>
                            <AddIcon /> Add a new building name
                          </Text>
                        </div>
                      )}
                    </Box>
                  </>)
                  : (<>
                    <FormTextField
                      label='Building Name' required value={manualInput}
                      validation={showError && validateBuildingName(manualInput)} onChange={setManualInput}
                      hint='Maximum 50 Characters' disabled={disabled}
                    />

                    <Box sx={{ marginBottom: '40px' }}>
                      {!disabled && (
                        <div onClick={switchBuildingNameField}>
                          <Text type='addBuildingNameCta'>
                            <SearchIcon /> Search from existing buildings
                          </Text>
                        </div>
                      )}
                    </Box>
                  </>
                    )
            }
    </div>
  )
}

export default BuildingName
